import style from "./ReviewForm.module.scss";
import Grid from "@mui/material/Grid";
import FormLayout from "../../../components/FormLayout";
import { formatSSN, formatPhone, formatMaskedSSN } from "../../../utils/dataConverter";
import { connect } from "react-redux";
import { useState } from "react";
import { userSetupSlice } from "../../../store/reducer/user_setup";
import CustomButton from "../../../components/CustomButton";
import { push } from "redux-first-history";
import { ErrorAlert } from "../../../components/Alerts";

const ReviewForm = ({
  dispatch,
  user,
  userError
}: any) => {

  const [reviewSuccessMode, setReviewSuccessMode] = useState(false);

  const _formData = {
    personalInfo: {
      firstName: user.first_name,
      lastName: user.last_name,
      ssn: user.social_security,
      phoneNo: user.phone_number,
      jointFiling: user.is_jointfiling,
    },
    spouseData: {
      firstName: user.spouse_first_name,
      lastName: user.spouse_last_name,
      ssn: user.spouse_social_security,
    },
    address: {
      streetAddress: user.address_1,
      aptAddress: user.address_2,
      city: user.city,
      state: user.state,
      zipCode: user.zip,
      residentForEntireYear: user.is_resident_for_the_entire_year
    }
  };

  const {
    personalInfo: { firstName, lastName, ssn, phoneNo, jointFiling },
    address: { streetAddress, aptAddress, city, state, zipCode, residentForEntireYear },
    spouseData,
  } = _formData;

  return (
    <FormLayout
      title={"Review"}
      subtitle={"review"}
      description={
        (reviewSuccessMode || userError)
          ? null
          : "Here’s all the data we’ve gathered so far. Now grab your Federal Tax Return and W-2s and we’ll get started filing your return."
      }
    >
      {userError && (
        <ErrorAlert>{userError}</ErrorAlert>
      )}
      {!userError && (reviewSuccessMode ? (<div>
        <p className={style.reviewText}>
          Great! We’ve collected all the personal information we need and LIME
          is ready to start preparing your return. Before we begin, check to
          make sure you have the following documents handy:
          
        </p>
        <ul className={style.reviewItemsList}>
          <li>Your Federal tax return</li>
          <li>Your W-2's</li>
        </ul>
      </div>
      ) : (
        <Grid container spacing={2} className={style.formContainer}>
          <Grid container>
            <Grid className={style.formRow} size={6}>
              <span className={style.fieldLabel}>First Name</span>
              <span className={style.fieldValue}>{firstName}</span>
            </Grid>
            <Grid className={style.formRow} size={6}>
              <span className={style.fieldLabel}>Last Name</span>
              <span className={style.fieldValue}>{lastName}</span>
            </Grid>
            <Grid className={style.formRow} size={12}>
              <span className={style.fieldLabel}>Social Security Number</span>
              <span className={style.fieldValue}>{formatMaskedSSN(ssn)}</span>
            </Grid>
            <Grid className={style.formRow} size={12}>
              <span className={style.fieldLabel}>Phone Number</span>
              <span className={style.fieldValue}>{formatPhone(phoneNo)}</span>
            </Grid>
            <Grid className={style.formRow} size={12}>
              <span className={style.fieldLabel}>Street Address</span>
              <span className={style.fieldValue}>{streetAddress}</span>
            </Grid>
            {aptAddress && (
              <Grid className={style.formRow} size={12}>
                <span className={style.fieldLabel}>
                  Apt, Suite, Bldg, Gate code
                </span>
                <span className={style.fieldValue}>{aptAddress}</span>
              </Grid>
            )}
            <Grid className={style.formRow} size={6}>
              <span className={style.fieldLabel}>City</span>
              <span className={style.fieldValue}>{city}</span>
            </Grid>
            <Grid className={style.formRow} size={6}>
              <span className={style.fieldLabel}>State</span>
              <span className={style.fieldValue}>{state}</span>
            </Grid>
            <Grid className={style.formRow} size={6}>
              <span className={style.fieldLabel}>Zip Code</span>
              <span className={style.fieldValue}>{zipCode}</span>
            </Grid>
            <Grid className={style.formRow} size={12}>
              <span className={style.fieldLabel}>Filing Status</span>
              <span className={style.fieldValue}>
                {jointFiling ? "Married" : "Single"}
              </span>
            </Grid>
          </Grid>
          {jointFiling && (
            <Grid container className={style.spouseDetails}>
              <Grid className={style.formRow} size={6}>
                <span className={style.fieldLabel}>First Name</span>
                <span className={style.fieldValue}>
                  {spouseData.firstName}
                </span>
              </Grid>
              <Grid className={style.formRow} size={6}>
                <span className={style.fieldLabel}>Last Name</span>
                <span className={style.fieldValue}>
                  {spouseData.lastName}
                </span>
              </Grid>
              <Grid className={style.formRow} size={12}>
                <span className={style.fieldLabel}>Social Security Number</span>
                <span className={style.fieldValue}>
                  {formatMaskedSSN(spouseData.ssn)}
                </span>
              </Grid>
            </Grid>
          )}
        </Grid>
      ))}
      {!userError && (<div className='btn-container'>
        <CustomButton
            variant="outlined"
            disableElevation={false}
            label={"back"}
            onClick={() => dispatch(push('/user/additional-info'))}
            buttonSize='btn-lg'
          />
        <CustomButton
          variant="contained"
          disableElevation={true}
          label={"next"}
          type="submit"
          onClick={() => {
            if (!reviewSuccessMode) {
              // This bool is used for conditional content rendered on page
              // and possibly primordial linkages to user flow
              setReviewSuccessMode(true);
              // Clear any existing exit error types which override subsequent fallback screens
              dispatch(userSetupSlice.actions.setExitMessageType(-1));
              dispatch(push("/upload/IRS1040"));
            } else {
              // TODO might need to add checkpoint and update persisted state here also?
              dispatch(userSetupSlice.actions.confirmStep());
            }
          }}
          buttonSize="btn-lg"
        />
      </div>)}
    </FormLayout>
  );
};

const mapStateToProps = (state: any) => { return { user: state.user.data, userError: state.user.error }; };

export default connect(mapStateToProps)(ReviewForm);
